import axios from "axios";

interface IProps {
  language: string;
  id: string;
}

interface IPropsCollection {
  language: string;
  limit?: number;
  table?: string;
  subCategory?: string;
}

export const getServices = async ({ limit = 3, language = "ar" }:IPropsCollection) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/services?_limit=${limit}&_locale=${language}`
  );
};
export const getMainSliderItems = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/main-slider-items?_locale=${language}`
  );
};
export const getNewsItems = async ({ limit = 3, language = "ar" }:IPropsCollection) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/news-items?_sort=id:DESC&_limit=${limit}&_locale=${language}`
  );
};
export const getImageGalleries = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/image-galleries`
  );
};


export const getMenu = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/menu?_locale=${language}`
  );
};

export const getSocialLinks = async () => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/social-links`
  );
};



export const getSingleImageGallery = async ({ language = "ar", id }: IProps) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/image-galleries/${id}`
  );
};

export const getOneNewsItem = async ({ language = "ar", id }: IProps) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/news-items/${id}?_locale=${language}`
  );
};

export const getOneService = async ({ language = "ar", id }: IProps) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/services/${id}?_locale=${language}`
  );
};

export const getOnePageItem = async ({ language = "ar", id }: IProps) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/pages/${id}?_locale=${language}`
  );
};

export const getOneDivisionItem = async ({ language = "ar", id }: IProps) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/Divisions/${id}`
  );
};

export const getOnePolicyItem = async ({ language = "ar", id }: IProps) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/Policies/${id}`
  );
};

export const getClients = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/clients?_locale=${language}`);
};

export const getPartners = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/partners?_locale=${language}`);
};

export const getContactInfo = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/contact-info?_locale=${language}`
  );
};


export const getBackgroundVideo = async () => {
  return axios.get(
    `${process.env.REACT_APP_CMS}/contact-info`
  );
};



export const getInternalPortalHomeSides = async ({ language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/home-sliders?_sort=id:ASC&_limit=5`);
};

export const getInternalPortalAnnouncements = async ({table="announcements",language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/${table}?_sort=id:DESC&_limit=20`);
};

export const getInternalPortalCyberSecuritys = async ({table="cyber-security",language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/${table}?_sort=id:DESC&_limit=20`);
};

export const getInternalPortalAnnouncementsASC = async ({table="announcements",language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/${table}?_sort=id:ASC&_limit=20`);
};


export const getInternalPortalFaqs = async ({subCategory="1",language = "ar" }: IPropsCollection) => {
  return axios.get(`${process.env.REACT_APP_CMS}/Faq-questions?faq_category=${subCategory}&_sort=id:ASC`);
};